import { computed, ComputedRef } from "vue";
import useCurrency, { ICurrencyType } from "@/apps/merchant3/shared-hooks/useCurrency";
import useLocale from "@/apps/merchant3/shared-hooks/useLocale";
import { formatCurrency } from "@/apps/merchant3/shared-helpers/currency-helper";
import { getCountryCode } from "@/apps/merchant3/helpers/country";

export const formatCurrencyFromMerchant = (
  amount: number | bigint,
  decimals?: number
): string => {
  const { getCurrency } = useCurrency();
  const { getLocale } = useLocale();

  const merchantCountry = getCountryCode().toUpperCase();

  const currency: ComputedRef<ICurrencyType> = computed(() => {
    return getCurrency(merchantCountry);
  });
  const locale = computed(() => {
    return getLocale(merchantCountry).localeWeb;
  });

  return formatCurrency(
    amount,
    locale.value,
    currency.value.code,
    decimals ?? currency.value.decimals
  );
};
